import { render } from "./BaseFieldData.vue?vue&type=template&id=21fdd9c8&scoped=true"
const script = {}

import "./BaseFieldData.vue?vue&type=style&index=0&id=21fdd9c8&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fdd9c8"]])

export default __exports__